import React from 'react'
import axios from 'axios';


class UpdateBanking extends React.Component {	  
	constructor(props) {
		super(props);
		this.state = {TTest:[]};				
	}

	componentDidMount() {				
		axios.post(process.env.REACT_APP_API_ENV+'api/SetupTables.php')
			.then(result => {
				this.setState({TTest:result.data})												
			})		
	}
	
	render() {		
		return(
			<div >	
				<h2>{this.state.TTest}</h2>
			</div>
		)
	}
}

export default UpdateBanking